import { render, staticRenderFns } from "./BookIssue.vue?vue&type=template&id=33a8110e&"
import script from "./BookIssue.vue?vue&type=script&lang=js&"
export * from "./BookIssue.vue?vue&type=script&lang=js&"
import style0 from "./BookIssue.vue?vue&type=style&index=0&id=33a8110e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports